import { ActionTree } from 'vuex'
import { ProfileState, UserData } from './types'
import { RootState } from '../types'
import { UserInfo } from 'firebase'
import { auth, db } from '@/firebase'
import EventBus from '../../EventBus'
import router from '../../router'

export const actions: ActionTree<ProfileState, RootState> = {
  // eslint-disable-next-line
  setUser ({ commit }, user: UserInfo): any {
    commit('setUser', user)
  },
  // eslint-disable-next-line
  updateUserData ({ state, commit }, userData: UserData): any {
    // merge current state
    const currentState: UserData = state.data ? state.data : new UserData()
    Object.assign(currentState, userData)
    commit('updateUserData', currentState)
  },
  // eslint-disable-next-line
  logout ({ commit }): any {
    auth.signOut()
  },
  // eslint-disable-next-line
  setOpenAuth ({ commit }, payload: {isOpen: boolean, to?: string}): any {
    if (payload.to) {
      commit('setTo', payload.to)
    }
    commit('setOpenAuth', payload.isOpen)
  },
  // save the current state to firestore
  async saveToFirestore ({ state }) {
    const uid = auth.currentUser?.uid
    if (uid) {
      await db.collection('users').doc(uid).set(Object.assign({}, state.data), { merge: true })
    }
  },
  async deleteAccount () {
    const user = auth.currentUser
    if (user) {
      // delete all ratings
      const allRatings = await db.collection('ratings').where('uid', '==', user.uid).get()
      allRatings.forEach(async (doc) => {
        await db.collection('ratings').doc(doc.id).delete()
      })

      // delete user config
      await db.collection('users').doc(user.uid).delete()

      // delete user from the auth system
      await user.delete()

      router.push('/')
      EventBus.$emit('message', { level: 'info', duration: 2000, message: 'Erledigt.', subline: 'Account wurde gelöscht!' })
    }
  }
}
